import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import Divider from 'material-ui/Divider';
import LoadingOverlay from 'react-loading-overlay';
import {withRouter} from 'react-router';
import {CharacterDetailRequiredLessons, CharacterDetailSupplements} from './index';
import {DocumentDownloader, Filter} from '../../shared/components';
import {getDisplayableShortGrade, handleApiError} from '../../shared/services';
import {List, Map} from 'immutable';
import {
  loadFilters,
  resetDownloadUrl,
  setDownloadUrl,
  updateFilters,
} from '../actions';
import React, {Component, PropTypes} from 'react';

class CharacterDetailLessonPlans extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  componentDidMount() {
    const {loadFilters, router} = this.props;

    loadFilters()
      .catch(error => handleApiError(error, router, 'An error occurred while attempting to load the lesson plan filters.', 'Error'));
  }

  displaySupplements(gradeCardData) {
    if (!gradeCardData.get('supplements').size) {
      return <div className="no-supplements-msg">None</div>;
    }

    const {setDownloadUrl} = this.props;

    return (
      <CharacterDetailSupplements
        gradeText={gradeCardData.get('long')}
        onMaterialDownload={setDownloadUrl}
        supplements={gradeCardData.get('supplements')} />
    );
  }

  render() {
    const {cardData, cardsLoading, downloadUrl, filters, resetDownloadUrl, updateFilters} = this.props;
    const gradeFilters = filters.get('grades');
    const activeGradeFilters = gradeFilters.filter(f => f.get('value'));

    const activeGradeData = activeGradeFilters.size
                              ? cardData.filter(d => activeGradeFilters.some(f => f.get('long') === d.get('long')))
                              : cardData;

    return (
      <div className={`character-details-lesson-plan-container ${cardsLoading ? 'loading' : ''}`}>
        { cardsLoading && <LoadingOverlay active={cardsLoading} text="Loading..." className="loading-overlay" />}
        { !cardsLoading &&
          <div>
            <div className="filter-container">
              <Filter filters={filters.toJS()} onFilterRequest={updateFilters} />
            </div>
            {activeGradeData.map(d =>
              <div key={d.get('id')} className="lesson-plan-grade-container">
                <div className="lesson-plan-grade">
                  <div className="lesson-plan-grade-title">{getDisplayableShortGrade(d.toJS())}</div>
                  <CharacterDetailRequiredLessons
                    gradeText={d.get('long')}
                    lessonPlans={d.get('requiredLessonPlans')} />
                  <div className="lesson-plan-supplemental-title">Additional Activities and Supplements</div>
                  { this.displaySupplements(d) }
                </div>
                <Divider />
              </div>
            )}
            <DocumentDownloader downloadUrl={downloadUrl} onDocumentDownloaded={resetDownloadUrl} />
          </div>
        }
      </div>
    );
  }
}

CharacterDetailLessonPlans.propTypes = {
  cardData: PropTypes.instanceOf(List).isRequired,
  cardsLoading: PropTypes.bool.isRequired,
  downloadUrl: PropTypes.string.isRequired,
  filters: PropTypes.instanceOf(Map).isRequired,
  loadFilters: PropTypes.func.isRequired,
  resetDownloadUrl: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  setDownloadUrl: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const {showLessonPlans} = state.features.characterDetail.pages;

  return {
    cardsLoading: showLessonPlans.get('cardsLoading'),
    downloadUrl: showLessonPlans.get('downloadUrl'),
    filters: showLessonPlans.get('filters'),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadFilters,
    resetDownloadUrl,
    setDownloadUrl,
    updateFilters,
  }
)(CharacterDetailLessonPlans));



// WEBPACK FOOTER //
// ./app/features/characterDetail/components/CharacterDetailLessonPlans.js